import { getAuthToken } from '../utils/auth';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';
const WS_URL = process.env.REACT_APP_WS_URL || 'ws://localhost:8000';

console.log('[Config] API:', API_URL);
console.log('[Config] WS:', WS_URL);

// HTTP client
export const apiClient = {
  async post(endpoint, data) {
    const token = getAuthToken();
    const response = await fetch(`${API_URL}${endpoint}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(token && { 'Authorization': `Bearer ${token}` })
      },
      body: JSON.stringify(data)
    });

    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      throw new Error(error.detail || 'Request failed');
    }

    return response.json();
  },

  async get(endpoint) {
    const token = getAuthToken();
    const response = await fetch(`${API_URL}${endpoint}`, {
      headers: {
        ...(token && { 'Authorization': `Bearer ${token}` })
      }
    });

    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      throw new Error(error.detail || 'Request failed');
    }

    return response.json();
  }
};

// WebSocket client - simple and reliable
export class PresenceWebSocket {
  constructor(classId, onMessage) {
    this.classId = classId;
    this.onMessage = onMessage;
    this.ws = null;
    this.reconnectAttempts = 0;
    this.maxReconnects = 10;
    this.shouldReconnect = true;
  }

  connect() {
    const token = getAuthToken();
    if (!token) {
      console.error('[WS] No token!');
      return;
    }

    const url = `${WS_URL}/ws/classes/${this.classId}?token=${token}`;
    console.log('[WS] Connecting...');

    try {
      this.ws = new WebSocket(url);
    } catch (e) {
      console.error('[WS] Failed to create:', e);
      return;
    }

    this.ws.onopen = () => {
      console.log('[WS] Connected!');
      this.reconnectAttempts = 0;
    };

    this.ws.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);
        if (data.type !== 'ping') {
          this.onMessage(data);
        }
      } catch (e) {
        console.error('[WS] Parse error:', e);
      }
    };

    this.ws.onerror = (e) => {
      console.error('[WS] Error:', e);
    };

    this.ws.onclose = (event) => {
      console.log('[WS] Closed:', event.code);

      if (this.shouldReconnect && this.reconnectAttempts < this.maxReconnects) {
        this.reconnectAttempts++;
        const delay = Math.min(1000 * this.reconnectAttempts, 5000);
        console.log(`[WS] Reconnecting in ${delay}ms...`);
        setTimeout(() => this.connect(), delay);
      }
    };
  }

  send(message) {
    if (this.ws && this.ws.readyState === WebSocket.OPEN) {
      this.ws.send(JSON.stringify(message));
      return true;
    }
    return false;
  }

  disconnect() {
    this.shouldReconnect = false;
    if (this.ws) {
      this.ws.close();
      this.ws = null;
    }
  }
}
